import actionTypes from './GISIPWPR01ActionType';

/**
 * 実習計画登録
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 作業計画登録初期を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getTrainingPlanInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TRAINING_PLAN_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_TRAINING_PLAN_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_TRAINING_PLAN_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_TRAINING_PLAN_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 実習計画を更新するReducer
 * @param {*} state
 * @param {*} action
 */
export const saveTrainingPlanInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_TRAINING_PLAN_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.SAVE_TRAINING_PLAN_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.SAVE_TRAINING_PLAN_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.SAVE_TRAINING_PLAN_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
